import { render, staticRenderFns } from "./ViewAddr.vue?vue&type=template&id=0534663d&scoped=true&"
import script from "./ViewAddr.vue?vue&type=script&lang=js&"
export * from "./ViewAddr.vue?vue&type=script&lang=js&"
import style0 from "./ViewAddr.vue?vue&type=style&index=0&id=0534663d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0534663d",
  null
  
)

export default component.exports